import Router from 'vue-router';
import Layout from '../views/layout';
import Home from '../views/home';
import About from '../views/about';
import Login from '../views/login';
import Mam from '../views/mam';

const routes= [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: '首页' }
    },
    {
      path: '/',
      redirect:"/home" // 重定向
    },
    {
      path: 'login',
      name: 'Login',
      component: Login,
      meta: { title: '登录' }
    },
    {
      path: '/mam',
      name: 'mam',
      component: Mam,
      meta: { title: 'MAM美安萌质量追溯' }
    },
   
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: '/home',
          component: Home,
          name: 'Home',
          meta: { title: '首页' }
        },
        {
          path: '/about',
          name: 'about',
          component: About,
          meta: { title: '关于我们' }
        },
      ],
    },
  ]

  const router = new Router({
    mode: 'history',
    routes
  });

  router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    } else {
      document.title = '默认标题';
    }
    next();
  });

  export default router;